// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"AlreadyRegistered_paragraph__G8tv-","link":"AlreadyRegistered_link__1EBTx"};